import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { StyledFlex } from '../../../styles/common';
import { StyledText } from '../../../styles/text';
export const StyledError = styled(StyledFlex) `
  @media ${mediaQueries.lessThanMedium} {
    padding: 30px 0 60px;
  }
`;
export const StyledErrorTextContainer = styled(Inset) `
  width: 100%;
`;
export const StyledSubheading = styled(StyledText) `
  margin: 0;
  white-space: pre-line;
`;
//# sourceMappingURL=subcomponents.js.map